import { lazy } from "react";

export const ChangedEmailPopup = lazy(() => import("./ChangedEmailPopup"));
